import CommonPasswordChange from '../../../common/pages/secure/PasswordChange'

class PasswordChange extends CommonPasswordChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
  }
}

export default PasswordChange



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/PasswordChange.js